import { useRef, useEffect, useState, useCallback } from 'react'

export const useHistogramWidths = (totalEffectiveBars: number, maxItemsPerBar: number[]) => {
    const containerRef = useRef<HTMLDivElement>(null)
    const [barWidths, setBarWidths] = useState<number[]>([])
    const [containerWidth, setContainerWidth] = useState<number>(0)
    
    const measureBarWidths = useCallback(() => {
        if (containerRef.current) {
            const container = containerRef.current
            const containerWidth = container.offsetWidth
            setContainerWidth(containerWidth)
            
            // Get all bar elements
            const barElements = container.querySelectorAll('[data-bar-index]')
            const widths: number[] = []
            
            barElements.forEach((element) => {
                const rect = element.getBoundingClientRect()
                widths.push(rect.width)
            })
            
            setBarWidths(widths)
        }
    }, [])
    
    // Measure bar widths when component mounts or bars change
    useEffect(() => {
        measureBarWidths()
    }, [totalEffectiveBars, maxItemsPerBar, measureBarWidths])
    
    // Handle window resize events
    useEffect(() => {
        const handleResize = () => {
            measureBarWidths()
        }
        
        window.addEventListener('resize', handleResize)
        
        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [measureBarWidths])
    
    return {
        containerRef,
        barWidths,
        containerWidth
    }
}
